import React from "react";
import { observer } from "mobx-react";
import { PlatformUpdateStore } from "../../store";
import { PlatformUpdateForm } from "./PlatformUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type PlatformUpdateProps = {
  platformUpdateStore: PlatformUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PlatformUpdate: React.FC<PlatformUpdateProps> = observer(
  ({ platformUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={platformUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={platformUpdateStore.savedButOutdated}
          onReload={() => platformUpdateStore.reloadPlatform()}
          reloadDisabled={platformUpdateStore.isProcessing}
        />
        <PlatformUpdateForm
          platformUpdateStore={platformUpdateStore}
          nameError={platformUpdateStore.errors.name?.message}
          onNameChange={(value: string) => {
            platformUpdateStore.setNameValue(value);
          }}
          name={platformUpdateStore.entityValues.name}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={platformUpdateStore.saveDisabled}
          onSave={() => platformUpdateStore.savePlatform()}
          onCancel={() => platformUpdateStore.cancelPlatform()}
        />
        <ErrorDialog
          open={platformUpdateStore.errorDialogOpened}
          title={platformUpdateStore.errorTitle}
          description={platformUpdateStore.errorDescription}
          onClose={() => platformUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={platformUpdateStore.confirmDialogOpened}
          title={platformUpdateStore.confirmDialogTitle}
          description={platformUpdateStore.confirmDialogDescription}
          onConfirm={() => platformUpdateStore.executeConfirmedAction()}
          onCancel={() => platformUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
